export default __webpack_public_path__ + "static/media/img_baseCrochet_rose.20a6ce89.jpg";